/* tslint:disable */
/**
 * This file is autogenerated using @sharefiledev/solution-view-engine-tools.
 *
 * Run 'sve typegen <relative path to manifest file>'
 *
 * Types are generated according to specification in a file that conforms to the UI Manifest schema:
 * https://us-solutionviewengine.sharefiletest.io/ui-manifest-v2.json
 */
import type {
	PiletApi,
	PiralCustomExtensionSlotMap as ShellPiralCustomExtensionSlotMap,
} from '@sharefiledev/sharefile-appshell';
import type { BlockParams } from '@sharefiledev/solution-view-engine';
import { StorageZone } from './types';

export interface ShellProps {
	piletApi: PiletApi;
}
/** Block parameters for urn:sfblock:storage:view:list */

export type OptionalColumnTypes =
	| 'addedIn'
	| 'type'
	| 'createdBy'
	| 'createdDate'
	| 'lastModifiedDate'
	| 'lastModifiedBy'
	| 'deletedDate'
	| 'deletedBy'
	| 'size';
export type ContextMenuActionType =
	| 'download'
	| 'preview'
	| 'rename'
	| 'delete'
	| 'share'
	| 'manage_users'
	| 'export'
	| 'send_for_signature'
	| 'send_for_approval'
	| 'edit_online'
	| 'edit_in_desktop'
	| 'open_folder_location'
	| 'move'
	| 'copy'
	| 'downloadAll'
	| 'upload'
	| 'createFolder'
	| 'import_from_ShareFile'
	| 'createOfficeDocs';
export type LocaleKey =
	| 'add_files'
	| 'add_files_from_shareFile'
	| 'add_from_shareFile'
	| 'cancel'
	| 'cancel_all'
	| 'clear_all'
	| 'close'
	| 'context_bar.no_selection'
	| 'context_bar.reset_selection'
	| 'context_bar.selected'
	| 'context_bar.share.not_permitted_folder_file_both'
	| 'continue'
	| 'create.button'
	| 'create.cancel'
	| 'create.create_document'
	| 'create.create_new_file_placeholder'
	| 'create.create_presentation'
	| 'create.create_spreadsheet'
	| 'create.created'
	| 'create.document'
	| 'create.file_name'
	| 'create.folder'
	| 'create.folder_creation_name_error'
	| 'create.folder_creation_success'
	| 'create.folder_details'
	| 'create.folder_details_error'
	| 'create.folder_details_placeholder'
	| 'create.folder_name_placeholder'
	| 'create.name'
	| 'create.presentation'
	| 'create.spreadsheet'
	| 'delete'
	| 'delete_alias'
	| 'delete_file_modal.alias_remove_title'
	| 'delete_file_modal.confirmation_alias_one'
	| 'delete_file_modal.confirmation_alias_other'
	| 'delete_file_modal.confirmation_one'
	| 'delete_file_modal.confirmation_other'
	| 'delete_file_modal.delete'
	| 'delete_file_modal.delete_version'
	| 'delete_file_modal.error_all_files'
	| 'delete_file_modal.error_some_files'
	| 'delete_file_modal.error_some_files_modified'
	| 'delete_file_modal.error_some_files_resource_not_found'
	| 'delete_file_modal.message_version'
	| 'delete_file_modal.remove'
	| 'delete_file_modal.remove_information_for_alias'
	| 'delete_file_modal.restore_files_information'
	| 'delete_file_modal.success_description'
	| 'delete_file_modal.title'
	| 'delete_file_modal.title_version'
	| 'delete_not_permitted'
	| 'delete_permamently.delete'
	| 'delete_permamently.error_all_files'
	| 'delete_permamently.error_some_files'
	| 'delete_permamently.message'
	| 'delete_permamently.success_description'
	| 'delete_permamently.title'
	| 'download'
	| 'downloadAll'
	| 'download_failed'
	| 'duplicateModal.message'
	| 'duplicateModal.message_version'
	| 'duplicateModal.message_versionWarning'
	| 'duplicateModal.replaceFile'
	| 'duplicateModal.replaceFile_version'
	| 'duplicateModal.title'
	| 'duplicateModal.title_version'
	| 'duplicateModal.version_cancel'
	| 'edit.cancel_text'
	| 'edit.checked_out_info'
	| 'edit.checked_out_title'
	| 'edit.close_text'
	| 'edit.edit'
	| 'edit.edit_desktop_confirm_message'
	| 'edit.edit_desktop_open_message'
	| 'edit.edit_desktop_title'
	| 'edit.edit_desktop_warning'
	| 'edit.edit_error'
	| 'edit.edit_in_microsoft_excel'
	| 'edit.edit_in_microsoft_powerpoint'
	| 'edit.edit_in_microsoft_word'
	| 'edit.edit_online'
	| 'edit.edit_online_learn_text'
	| 'edit.edit_online_open_message'
	| 'edit.edit_online_text'
	| 'edit.edit_online_title'
	| 'edit.edit_trouble_text'
	| 'edit.learn_more_text'
	| 'edit.sign_in_checkbox_text'
	| 'edit.sign_in_message'
	| 'edit.sign_in_post_script_text'
	| 'edit.sign_in_sharefile_title'
	| 'edit.sign_in_text'
	| 'edit.try_again_text'
	| 'error.generic_error'
	| 'error.unauthorized'
	| 'error_code.delete.30002'
	| 'error_code.delete.30003'
	| 'error_code.delete.30012'
	| 'error_code.delete.30018'
	| 'error_code.delete.30029'
	| 'error_code.delete_permamently.30002'
	| 'error_code.delete_permamently.30003'
	| 'error_code.delete_permamently.30012'
	| 'error_code.delete_permamently.30018'
	| 'error_code.delete_permamently.30029'
	| 'error_code.download.30005'
	| 'error_code.download.30026'
	| 'error_code.download.30027'
	| 'error_code.download.30033'
	| 'error_code.edit_resource.30026'
	| 'error_code.edit_resource.30027'
	| 'error_code.edit_resource.30036'
	| 'error_code.edit_resource.30042'
	| 'error_code.edit_resource.30043'
	| 'error_code.file_create.30006'
	| 'error_code.file_create.30011'
	| 'error_code.file_create.30012'
	| 'error_code.file_create.30024'
	| 'error_code.file_create.30036'
	| 'error_code.file_create.30037'
	| 'error_code.file_create.30041'
	| 'error_code.file_create.30048'
	| 'error_code.folder_create.30006'
	| 'error_code.folder_create.30011'
	| 'error_code.folder_create.30012'
	| 'error_code.folder_create.30024'
	| 'error_code.folder_create.30036'
	| 'error_code.folder_create.30037'
	| 'error_code.folder_create.30041'
	| 'error_code.folder_create.30048'
	| 'error_code.preview.30002'
	| 'error_code.preview.30005'
	| 'error_code.preview.30026'
	| 'error_code.preview.30027'
	| 'error_code.rename.30001'
	| 'error_code.rename.30002'
	| 'error_code.rename.30003'
	| 'error_code.rename.30024'
	| 'error_code.rename.30040'
	| 'error_code.rename.30041'
	| 'error_code.restore.30002'
	| 'error_code.restore.30003'
	| 'error_code.restore.30012'
	| 'error_code.restore.30018'
	| 'error_code.restore.30024'
	| 'error_code.restore.30030'
	| 'error_code.tagging.30002'
	| 'error_code.userSync.30011'
	| 'error_codes.30006'
	| 'error_codes.30011'
	| 'error_codes.30012'
	| 'error_codes.30013'
	| 'error_codes.30017'
	| 'error_codes.30018'
	| 'error_codes.30021'
	| 'error_codes.30024'
	| 'error_codes.30034'
	| 'error_codes.30035'
	| 'error_modal.cancel_all'
	| 'error_modal.import_error_modal_title'
	| 'error_modal.upload_error_modal_title'
	| 'error_reasons.400'
	| 'error_reasons.401'
	| 'error_reasons.404'
	| 'error_reasons.409'
	| 'error_reasons.412'
	| 'error_reasons.500'
	| 'error_reasons.default'
	| 'export'
	| 'file_upload_failed'
	| 'files'
	| 'files_table.added_by'
	| 'files_table.added_in'
	| 'files_table.date_added'
	| 'files_table.date_deleted'
	| 'files_table.date_updated'
	| 'files_table.deleted_by'
	| 'files_table.deleted_on'
	| 'files_table.last_modified_by'
	| 'files_table.limitation_warning'
	| 'files_table.limitation_warning_other'
	| 'files_table.name'
	| 'files_table.size'
	| 'files_table.type_tag'
	| 'files_uploaded'
	| 'home'
	| 'import.cancel'
	| 'import.failed_all'
	| 'import.failed_some'
	| 'import.files'
	| 'import.from_sharefile'
	| 'import.import'
	| 'import.link_to_container'
	| 'import.success'
	| 'import_from_shartfile.error_codes.30006'
	| 'import_from_shartfile.error_codes.30007'
	| 'import_from_shartfile.error_codes.30009'
	| 'import_from_shartfile.error_codes.30048'
	| 'import_from_shartfile.error_codes.default'
	| 'malware.infected_message'
	| 'malware.infected_modal_message_1'
	| 'malware.infected_modal_message_2'
	| 'malware.infected_modal_title'
	| 'malware.scanning_message'
	| 'malware.scanning_modal_title'
	| 'manage_users'
	| 'more'
	| 'move_copy.action.copy'
	| 'move_copy.action.move'
	| 'move_copy.modal.cancel'
	| 'move_copy.modal.create_folder'
	| 'move_copy.modal.header'
	| 'move_copy.modal.ok_copy'
	| 'move_copy.modal.ok_move'
	| 'move_copy.modal.title_copy_one'
	| 'move_copy.modal.title_copy_other'
	| 'move_copy.modal.title_move_one'
	| 'move_copy.modal.title_move_other'
	| 'move_copy.notification.copy_one'
	| 'move_copy.notification.copy_other'
	| 'move_copy.notification.move_one'
	| 'move_copy.notification.move_other'
	| 'ok'
	| 'open_folder_location'
	| 'open_folder_location_error.message'
	| 'open_folder_location_error.title'
	| 'permissions.file.additionalPermissionsTooltip'
	| 'permissions.file.delete'
	| 'permissions.file.download'
	| 'permissions.file.edit'
	| 'permissions.file.inheritedPermissionsAlertMessage'
	| 'permissions.file.modify'
	| 'permissions.file.remove_success'
	| 'permissions.file.share'
	| 'permissions.file.shareModalTitle'
	| 'permissions.file.share_entity'
	| 'permissions.file.share_error'
	| 'permissions.file.share_success'
	| 'permissions.file.view'
	| 'permissions.folder.additionalPermissionsTooltip'
	| 'permissions.folder.create'
	| 'permissions.folder.delete'
	| 'permissions.folder.download'
	| 'permissions.folder.inheritedPermissionsAlertMessage'
	| 'permissions.folder.modify'
	| 'permissions.folder.remove_success'
	| 'permissions.folder.share'
	| 'permissions.folder.shareModalTitle'
	| 'permissions.folder.share_entity'
	| 'permissions.folder.share_error'
	| 'permissions.folder.share_success'
	| 'permissions.folder.view'
	| 'permissions.preset.download'
	| 'permissions.preset.edit'
	| 'permissions.preset.owner'
	| 'permissions.preset.upload'
	| 'permissions.preset.view'
	| 'permissions.relatedResources.canShareProjectDescription'
	| 'permissions.relatedResources.canViewProjectDescription'
	| 'permissions.relatedResources.projectLabel'
	| 'preview'
	| 'preview_failure_reasons.default'
	| 'preview_failure_reasons.resource_not_found'
	| 'rename'
	| 'rename_error'
	| 'restore.button_text'
	| 'restore.conflict_message'
	| 'restore.conflict_title'
	| 'restore.empty_message'
	| 'restore.failed_all'
	| 'restore.failed_some'
	| 'restore.success'
	| 'save'
	| 'select_files'
	| 'send_for_approval'
	| 'send_for_signature'
	| 'share'
	| 'share_messages.invalid_file_resource'
	| 'share_messages.share_not_permitted'
	| 'storage_zone_dropdown.heading'
	| 'storage_zone_dropdown.label_description'
	| 'storage_zone_dropdown.label_description_readonly'
	| 'storage_zone_dropdown.label_description_solution'
	| 'storage_zone_dropdown.label_message'
	| 'storage_zone_dropdown.partner_managed_cloud_type'
	| 'storage_zone_dropdown.private_cloud_type'
	| 'storage_zone_dropdown.public_cloud_type'
	| 'storage_zone_dropdown.storage_zone_error'
	| 'storage_zone_dropdown.tooltip_message'
	| 'type_tag.folder'
	| 'type_tag.inforeq'
	| 'type_tag.legal_solution'
	| 'type_tag.project'
	| 'type_tag.requestlist'
	| 'type_tag.requestlist_item'
	| 'type_tag.signature_request'
	| 'type_tag.table'
	| 'type_tag.tax_solution'
	| 'upload.add_more'
	| 'upload.browse_files'
	| 'upload.byte_units.B'
	| 'upload.byte_units.EB'
	| 'upload.byte_units.GB'
	| 'upload.byte_units.KB'
	| 'upload.byte_units.MB'
	| 'upload.byte_units.PB'
	| 'upload.byte_units.TB'
	| 'upload.byte_units.YB'
	| 'upload.byte_units.ZB'
	| 'upload.cancel_all_modal_content'
	| 'upload.cancel_upload'
	| 'upload.drag_files'
	| 'upload.drop_files'
	| 'upload.empty.folder_message'
	| 'upload.empty.folder_title'
	| 'upload.empty.message'
	| 'upload.empty.title'
	| 'upload.keep_uploading'
	| 'upload.retry.retry_modal_heading'
	| 'upload.retry.upload_failed'
	| 'upload.storage_limit_exceeded'
	| 'upload.upload'
	| 'upload.upload_failed'
	| 'upload.upload_failed_for_some'
	| 'upload.upload_file'
	| 'upload.upload_in_progress'
	| 'upload.upload_modal_button'
	| 'upload.upload_success'
	| 'upload.upload_success_other'
	| 'upload_from_device'
	| 'upload_from_local'
	| 'version_enumeration_window.cancel_text'
	| 'version_enumeration_window.download_all_text'
	| 'version_enumeration_window.last_modified_by'
	| 'version_enumeration_window.last_updated'
	| 'version_enumeration_window.version_history_text'
	| 'version_tooltip_message'
	| 'view_all'
	| 'view_details';

export interface ViewListBlockParams {
	containerRID: string;
	customizationData?: {
		columns?: OptionalColumns;
		columnsList?: OptionalColumnTypes[];
		contextMenu?: ContextMenuItem[];
		disableSelection?: boolean;
		disableTableHeader?: boolean;
		disableColumnSorting?: boolean;
		disableColumnFiltering?: boolean;
		disableOverallUploadProgress?: boolean;
		pagination?: Pagination;
		labels?: Locale[];
		relatedResourcesForShare?: RelatedResource[];
		styles?: ContainersStyle;
		singleResourceAutoPreview?: boolean;
		sideLoadByAssociation?: SideLoadByAssociation;
		selectLoadedResourcesByDefault?: boolean;
		hideAllActionsOnHover?: boolean;
		analyticPrefix?: string;
		allowOnlySingleResourceSelection?: boolean;
	};
	resourceFetchOptions?: ResourceFetchOptions;
}
export interface OptionalColumns {
	addedIn?: boolean;
	type?: boolean;
	createdBy?: boolean;
	createdDate?: boolean;
	lastModifiedDate?: boolean;
	lastModifiedBy?: boolean;
	deletedDate?: boolean;
	deletedBy?: boolean;
	size?: boolean;
}
export interface ContextMenuItem {
	/**
	 * Button type
	 */
	type?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
	/**
	 * Button size
	 */
	size?: 'small' | 'middle' | 'large';
	menuType: ContextMenuActionType;
	showIconOnly?: boolean;
}
export interface Pagination {}
export interface Locale {
	key: LocaleKey;
	value: LocalizedString;
}
/**
 * Localized String Values
 */
export interface LocalizedString {
	en?: string;
	es?: string;
	de?: string;
	fr?: string;
	it?: string;
	ja?: string;
	nl?: string;
	'pt-BR'?: string;
}
export interface RelatedResource {
	rid: string;
	permissions?: string[];
	required?: boolean;
	relationshipLabel?: string;
	relationshipDescription?: string;
	isRequiredWhenOneOfSelectedPermissions?: string[];
}
export interface ContainersStyle {
	scrollableContainerStyle?: {
		[k: string]: unknown;
	};
}
export interface SideLoadByAssociation {
	byContainerRIDs?: string[];
	byTags?: TagFilter;
}
export interface TagFilter {
	includeTags?: Tag[];
	excludeTags?: Tag[];
}
export interface Tag {
	name: string;
	value: string;
}
export interface ResourceFetchOptions {
	/**
	 * ExcludeDeleted = 0, IncludeDeleted = 1, OnlyDeleted = 2
	 */
	deletedResourceRetrievalType?: 0 | 1 | 2;
	tags?: string[];
	tagFilters?: TagFilter;
	subResourceFilter?: {
		includeResourceRids?: string[];
	};
}
/** Block parameters for urn:sfblock:storage:file-viewer */

/**
 * If you must use this component as an extension slot for the onCompleteInteraction callback, then use urn:sfextslot:storage-plugin-pilet:file-viewer instead.
 */
export interface FileViewerBlockParams {
	containerRID: string;
	fileRID: string;
	fileViewerConfig?: {};
	capabilities?: {
		uploadCapabilities: UploadCapabilities;
		downloadCapabilities: DownloadCapabilities;
		accountCapabilities: AccountCapabilities;
		createCapabilities?: CreateCapabilities;
		containerCapabilities: ContainerCapabilities;
		zoneCapabilities?: ZoneCapabilities;
	};
}
export interface UploadCapabilities {
	canUpload: boolean;
	isStorageEnforcementEnabled: boolean;
	supportedUploadMethods: string[];
	isVersioningEnabled: boolean;
}
export interface DownloadCapabilities {
	canDownload: boolean;
}
export interface AccountCapabilities {
	/**
	 * WarnOnly = 0, BlockInfected = 1, BlockUnscannedAndInfected = 2
	 */
	virusStrictness: 0 | 1 | 2;
}
export interface CreateCapabilities {
	canCreateFolder: boolean;
}
export interface ContainerCapabilities {
	isEditingEnabled: boolean;
}
export interface ZoneCapabilities {
	isZoneSelectionEnabled: boolean;
	accountStorageZones: StorageZone[];
}

export namespace BlockNames {
	export const ViewList = 'urn:sfblock:storage:view:list' as const;
	export type ViewList = 'urn:sfblock:storage:view:list';
	export const FileViewer = 'urn:sfblock:storage:file-viewer' as const;
	export type FileViewer = 'urn:sfblock:storage:file-viewer';
}

export namespace ZoneTypes {}

export type ViewListProps = ShellProps & BlockParams & ViewListBlockParams;
export type FileViewerProps = ShellProps & BlockParams & FileViewerBlockParams;

declare module '@sharefiledev/sharefile-appshell' {
	interface PiralCustomExtensionSlotMap {
		['urn:sfblock:storage:view:list']: BlockParams & ViewListBlockParams;
		['urn:sfblock:storage:file-viewer']: BlockParams & FileViewerBlockParams;
	}
}

declare module '@sharefiledev/solution-view-engine' {
	interface BlockCustomExtensionSlotMap extends ShellPiralCustomExtensionSlotMap {}

	interface PiletExtensionApi extends PiletApi {}

	interface ViewEngineCustomZoneParametersMap {}

	interface ViewEngineCustomZoneContractDataMap {}
}
